import { render, staticRenderFns } from "./StatsOperationControl.vue?vue&type=template&id=ddc6650a&"
import script from "./StatsOperationControl.vue?vue&type=script&lang=js&"
export * from "./StatsOperationControl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports